import React from 'react'
import * as Yup from 'yup'
import { Box } from '../../designSystem'
import {
  LoginButton,
  LoginHeading,
  FrogetPasswordLabel,
  ResendTryAgainButton,
} from './styles'
import { Formik, Form } from 'formik'
import { FloatingInput } from '../FormikInputs'
import { emailValidation } from '../../lib/utils'
import Loader from '../Loader'
import { post } from '../../lib/api'

function ForgotPassword({
  email,
  message,
  setMessage,
  activationButton,
  setActivationButton,
  onActivationClick,
  setEmail
}) {
  return (
    <>
      <LoginHeading>Password Reset </LoginHeading>
      {message?.text !== 'passwordChangdSuccessfully' &&
        message?.text !== 'passwordChangeFailed' && (
          <FrogetPasswordLabel>
            Enter the email address and we'll send you a link to reset your
            password.
          </FrogetPasswordLabel>
        )}
      {message.text === 'passwordChangdSuccessfully' && (
        <FrogetPasswordLabel>
          We’ve sent you an email with password reset link, be sure to check the
          spam folder, incase you don’t find it.
        </FrogetPasswordLabel>
      )}
      {message.text === 'passwordChangeFailed' && (
        <FrogetPasswordLabel>
          We can’t find any account associated with the email address {email}.
        </FrogetPasswordLabel>
      )}
      <Formik
        initialValues={{
          email: '',
        }}
        validationSchema={Yup.object({
          email: Yup.string().required('Required'),
        })}
        onSubmit={(values, { setSubmitting }) => {
          setActivationButton(false)
          // setMessage({...message ,"text":""});
          setEmail(values.email)
          post(`/user_api/user.password_reset_email?is_novel=1`, {
            data: {
              email: values.email,
            },
          })
            .then((response) => {
              setSubmitting(false)
              setMessage({ text: 'passwordChangdSuccessfully', color: 'green' })
            })
            .catch((error) => {
              setSubmitting(false)
              setMessage({
                ...message,
                text: 'passwordChangeFailed',
                color: 'red',
              })
            })
        }}
      >
        {({ values = {}, isSubmitting, errors, resetForm }) => (
          <Form>
            {message.text !== 'passwordChangdSuccessfully' &&
              message.text !== 'passwordChangeFailed' && (
                <>
                  <Box width="100%" mb={16}>
                    <FloatingInput
                      type="text"
                      name="email"
                      label="Email ID"
                      size="lg"
                    />
                  </Box>
                  <Box width="100%" mb={16}>
                    <LoginButton
                      id="login-handler"
                      disabled={!emailValidation(values.email)}
                      type="submit"
                    >
                      {isSubmitting ? (
                        <Loader size="sm" invertColor noPadding />
                      ) : (
                        'continue'
                      )}
                    </LoginButton>
                  </Box>
                </>
              )}

            {message.text === 'passwordChangdSuccessfully' && (
              <ResendTryAgainButton isSubmitting={isSubmitting} type="submit">
                {isSubmitting ? (
                  <Loader size="sm" invertColor noPadding />
                ) : (
                  'Resend Link'
                )}
              </ResendTryAgainButton>
            )}
            {message.text === 'passwordChangeFailed' && (
              <ResendTryAgainButton isSubmitting={isSubmitting} type="submit">
                {isSubmitting ? (
                  <Loader size="sm" invertColor noPadding />
                ) : (
                  'Try Again'
                )}
              </ResendTryAgainButton>
            )}
          </Form>
        )}
      </Formik>
      {activationButton && (
        <Box mt={16}>
          <LoginButton type="notsubmit" onClick={() => onActivationClick()}>
            Resend Email Activation Link
          </LoginButton>
        </Box>
      )}
    </>
  )
}

export default ForgotPassword